module.exports = __webpack_public_path__ + "static/media/ophos-blue-shadow.87842518.svg";